import { ParentOrganization } from '../data/models/parent-organization.model';

class ParentOrganizationsUtils {
  public getParentOrganizationDefaults(organization?: ParentOrganization): any {
    const organizationData = {
      parentOrganizationBC: organization?.parentOrganizationBC || '',
      parentOrganizationName: organization?.parentOrganizationName || '',
      isInternal:
        organization && typeof organization.isInternal === 'boolean'
          ? organization.isInternal
          : false,
    };
    return organizationData;
  }

  public getOrganizationFromFormData(
    formData: ParentOrganization,
    isNew: boolean,
  ): ParentOrganization {
    const organization: ParentOrganization = {
      parentOrganizationBC: formData.parentOrganizationBC,
      parentOrganizationName: formData.parentOrganizationName,
      isInternal: formData.isInternal,
    };

    return organization;
  }
}

export const parentOrganizationsUtils = new ParentOrganizationsUtils();
